module.exports = __webpack_public_path__ + "img/firecontrol.ae39aa15.png";